<template>
  <page>
    <template slot="title">Энерготрейдинг</template>
    <template slot="section">
      <columns>
        <column size="10">
          <p>Согласно действующему законодательству, для отдельных групп крупных промышленных потребителей существует возможность самостоятельного получения статуса субъекта оптового рынка электроэнергии и мощности (ОРЭМ). В этом случае отсутствует необходимость «прослойки» в виде энергосбытовой компании, покупка электроэнергии происходит у оптовых поставщиков – генерирующих компаний, а статус субъекта ОРЭМ получает непосредственно предприятие или группа компаний.</p>
          <p>Данное обстоятельство гарантирует безопасность финансовых расчетов потребителя с поставщиками и обеспечивает прозрачность цены для собственников крупного бизнеса. </p>
          <p>Мы готовы комплексно сопроводить процедуру получения статуса субъекта ОРЭМ с последующим заключением договора энерготрейдинга. Договор включает осуществление процедуры покупки, планирование потребления электроэнергии, предоставление всех необходимых отчетов и аналитики, взаимодействие с финансовыми службами предприятия в рамках составления бюджета и планирования платежей, при этом платежная система «потребитель – поставщик» предполагает прямые расчеты.</p>
        </column>
      </columns>
    </template>
    <template slot="aside">
      <aside-image :image="imageBg"/>
    </template>
  </page>
</template>

<script>
import imageBg from '../../static/i/img-14.jpg';

import Columns from '@/components/columns/Columns';
import Column from '@/components/columns/Column';
import Page from '@/components/Page';
import AsideImage from '@/components/AsideImage';

export default {
  components: {
    Columns,
    Column,
    Page,
    AsideImage,
  },
  data: () => {
    return {
      imageBg: imageBg,
    }
  }
}
</script>



// WEBPACK FOOTER //
// Trading.vue?0a65d709